import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const VisibilityLight: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.27532 2.46684L2.19452 4.77112V3.93175C2.12966 3.40432 2.18854 2.87017 2.3669 2.36789C2.54525 1.86562 2.83881 1.40946 3.22453 1.0338C3.61025 0.657297 4.0796 0.371359 4.59589 0.196107C5.11132 0.021693 5.6626 -0.0378426 6.20619 0.02337H11.5781C12.1209 -0.0378426 12.6713 0.021693 13.1876 0.196107C13.7039 0.371359 14.1724 0.657297 14.5581 1.03296C14.9438 1.40862 15.2374 1.86394 15.4157 2.36538C15.5941 2.86682 15.6538 3.40096 15.5898 3.92756V4.75518L11.509 2.46181C10.7051 2.03835 9.80569 1.81698 8.89174 1.81782C7.97778 1.81782 7.07833 2.04171 6.27532 2.466V2.46684Z"
        fill="#45D88E"
      />
      <path
        d="M15.7793 6.76276L15.62 6.67185L14.0359 5.76279L10.7666 3.88036C10.2217 3.59563 9.61599 3.44727 9 3.44727C8.38401 3.44727 7.7783 3.59563 7.23341 3.88036L3.96411 5.76279L2.38001 6.68043L2.17525 6.7962C0.137934 8.15551 0 8.40507 0 10.5937V15.819C0 18.0068 0.137078 18.2564 2.22151 19.6508L7.23341 22.5349C7.77401 22.8308 8.38315 22.9783 9 22.9646C9.61685 22.9757 10.226 22.8257 10.7666 22.5306L15.8239 19.6165C17.8629 18.2564 18 18.0068 18 15.8199V10.5945C18 8.40593 17.8629 8.15636 15.7785 6.76362L15.7793 6.76276Z"
        fill="white"
      />
      <path
        d="M11.3176 11.1709C10.5888 10.7423 9.79762 10.5176 8.98194 10.5176C6.20385 10.5176 4.65448 13.1009 4.59766 13.1553C4.66077 13.2158 6.1222 15.795 8.98194 15.795C11.76 15.795 13.3177 13.2019 13.3662 13.1553C13.2789 13.0522 12.6598 11.9582 11.3176 11.1709ZM8.98194 15.0605C7.93213 15.0605 7.07868 14.207 7.07868 13.1572C7.07868 12.1074 7.93213 11.254 8.98194 11.254C10.0317 11.254 10.8852 12.1074 10.8852 13.1572C10.8852 14.207 10.0317 15.0605 8.98194 15.0605Z"
        fill="#1B3029"
      />
      <path
        d="M9.39117 12.7434C9.10319 12.4554 9.18384 12.118 9.17082 12.0215H8.98201C8.3573 12.0215 7.84912 12.5297 7.84912 13.1544C7.84912 13.7684 8.36799 14.2873 8.98201 14.2873C9.60672 14.2873 10.1149 13.7791 10.1149 13.1544V12.9656C10.0164 12.9522 9.68026 13.0321 9.39117 12.7434Z"
        fill="#1B3029"
      />
      <path d="M8.79248 9.19531H9.17011V9.95605H8.79248V9.19531Z" fill="#1B3029" />
      <path d="M11.4878 10.3848L12.0258 9.84671L12.2929 10.1137L11.7548 10.6518L11.4878 10.3848Z" fill="#1B3029" />
      <path d="M5.66895 10.1172L5.93597 9.85016L6.47389 10.3881L6.20687 10.6551L5.66895 10.1172Z" fill="#1B3029" />
      <path d="M8.79248 16.3574H9.17011V17.1184H8.79248V16.3574Z" fill="#1B3029" />
      <path d="M5.66748 16.1992L6.2054 15.6613L6.47243 15.9283L5.9345 16.4662L5.66748 16.1992Z" fill="#1B3029" />
      <path d="M11.4868 15.9297L11.7538 15.6627L12.2919 16.2007L12.0249 16.4677L11.4868 15.9297Z" fill="#1B3029" />
    </svg>
  )
})

VisibilityLight.displayName = 'VisibilityLight'
